import { halfEdgeY } from '../../utils/hexGeometry'

// Corridor geometry for item A (war snapshot), mirroring the React lab's
// components/v2/hex/geometry.js plotTileBox / laneBox, but scaled by the
// scene's hex radius R (the lab's version is fixed at R = 375/32).
//   slot p of corridor c: a 4.5R x 3H tile, slot 0 nearest the band
//   drone tile: a disc of radius 1.8R in the tile's centre
//   capacity lane: a capsule round slots 0..cap-1, padded 2 px at R = 375/32

const LAB_R = 375 / 32
export const droneRadius = R => 1.8 * R
export const laneRadius = R => 1.8 * R + (2 / LAB_R) * R

export function tileCenter(side, c, p, R) {
    const H = Math.sqrt(3) * R
    const left = 4.5 * R * c + 0.25 * R
    const d0 = 3 * H * p + H / 4
    const near = side === 'self' ? halfEdgeY('self', R) + d0 : halfEdgeY('opp', R) - d0
    const top = side === 'self' ? near : near - 3 * H
    return { x: left + 2.25 * R, y: top + 1.5 * H }
}

// The lane capsule for capacity `cap`: centre and on-screen size.
export function laneGeometry(side, c, cap, R) {
    const first = tileCenter(side, c, 0, R)
    const last = tileCenter(side, c, cap - 1, R)
    const r = laneRadius(R)
    return { x: first.x, y: (first.y + last.y) / 2, w: 2 * r, h: Math.abs(last.y - first.y) + 2 * r }
}
